<div class="free-beats-page">
  <div class="common-container">
    <h2 class="common-section-title common-section-title--catalog">
      {{ lg.freeBeatsPage.headings.freeBeats }}
    </h2>

    <!-- Tracks block -->
    <div class="free-beats-page_content">
      <bmcore-tracks-block
        [appType]="appType"
        [isTracksPage]="true"
        [isShowTracksAllBeatmakers]="true"
        [showSearchFields]="false"
        [pageSize]="20"
        [pagesWithFilter]="'production-mode'"
        [currentSortById]="FreeBeatsSortBy.AddedDateDesc"
      >
      </bmcore-tracks-block>
    </div>
  </div>
</div>
